export default ({ state, commit }, navDirection) => {
  const elmIndex = state.list.findIndex((elm) => elm._id === state.selectedItem._id)
  const itemSelected = state.list[elmIndex + navDirection]
  if (!itemSelected) return

  commit('SET_SELECTED_ITEM', { itemDetail: itemSelected })
}



// WEBPACK FOOTER //
// ./src/brain/item-association/NavigateMap.js